import type * as React from 'react';
import { localStorageSet } from '@Infra/LocalStorage';
import { LOCAL_STORAGE_KEYS } from '@Infra/LocalStorage/keys';
import installPromptDismissed, {
	type InstallPromptDismissedAction,
} from '@Application/ApplicationSettings/InstallPrompt/Actions/installPromptDismissed';
import readInstallPromptDismissal, {
	type PersistedDismissalShape,
} from '@Application/ApplicationSettings/InstallPrompt/readInstallPromptDismissal';

/**
 * Recording a refusal is a purely local side effect — no server call, no business payload beyond
 * the resulting dismissal state — the exact case the application layer guide covers for a file
 * export: an action is still dispatched and returned, never `Promise<void>`.
 */
export default () => {
	return async (
		dispatch: React.Dispatch<InstallPromptDismissedAction>,
	): Promise<InstallPromptDismissedAction> => {
		const priorDismissalRecord = readInstallPromptDismissal();
		const dismissalCount = (priorDismissalRecord?.dismissalCount ?? 0) + 1;
		const lastDismissedAtMs = Date.now();

		const persistedDismissalState: PersistedDismissalShape = {
			dismissalCount,
			lastDismissedAt: new Date(lastDismissedAtMs).toISOString(),
		};

		localStorageSet(
			LOCAL_STORAGE_KEYS.INSTALL_BANNER_DISMISSAL_STATE,
			JSON.stringify(persistedDismissalState),
		);

		const action = installPromptDismissed({ dismissalCount, lastDismissedAtMs });
		dispatch(action);
		return action;
	};
};
